angular.module('impactx.userdialog').controller('UserAuthorizationCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'TranslationService',
    'ToastService',
    'BackService',
    'RelationViewHelperService',
    'ToolbarService',
    'PartialDialogsService',
    UserAuthorizationCtrl
]);

function UserAuthorizationCtrl($scope, dataGen, $routeParams, TranslationService, ToastService, BackService,
                               RelationViewHelperService, ToolbarService, PartialDialogsService) {
    var usgCatalogListPromise,
        userId,
        backendEndpoint = "/user/authorizations/view",
        self = this;

    userId = $routeParams.id;

    self.usgCatalogRelation = {};

    $scope.items = ['item1', 'item2', 'item3'];
    $scope.productmenu = {menuitems: [{label: 'Placeholder', view: 'lobby'}]};
    $scope.showToolbar = false;

    $scope.toggleToolbar = function() {
        $scope.showToolbar = !$scope.showToolbar;
    };

    $scope.getPageData = function() {
        dataGen.getData($scope, {id: userId}, backendEndpoint).then(function() {
            var authorizationEntry, authorization;

            if($scope.data.authSets) {
                $scope.handleChange();

                authorizationEntry = $scope.data.authSets.authSetEntries[0];
                if(authorizationEntry && authorizationEntry.authSetId > 0) {
                    authorization = $scope.data.authSets.authorizationPopup.entries.filter(function(a) {
                        return a.id == authorizationEntry.authSetId
                    })[0];
                    if(authorization && authorization.isSuperUser && !authorizationEntry.deleted) {
                        $scope.data.isSuperUser = true;
                    }
                }
            }
            defineButtons();
        });
    };

    /**
     * Checks the event name whether it's from a relation and important.
     * @param eventName event name to check
     * @return {boolean} true when important
     */
    self.isImportantEventFromRelationView = function(eventName) {
        return (eventName === 'rv.assignAll' || eventName === 'rv.unassignAll' || eventName === 'rv.revertDeletion');
    };

    /**
     * Event handler method.
     * @param eventName event name
     * @param data event data
     * @param eventSource event source
     */
    self.onUXEvent = function(eventName, data, eventSource) {
        var expectedUsgRelationId = 'relation-dialog-2';

        //Currently only for one event-source
        if(self.isImportantEventFromRelationView(eventName) && eventSource &&
            (typeof eventSource.getRelationId === 'function') && eventSource.getRelationId() === expectedUsgRelationId) {

            self.updateInheritedCatalogList(data);
        }
    };

    /**
     * Shows/hides the list of catalogs inherited from companies.
     */
    self.showCompanyCatalogs = function() {
        var replaceWith = [],
            doShowCompanyCatalogs = !impactX.isDefined($scope.data.usrvcat, 'hideCompanyCatalogs.value');

        $scope.$broadcast('rv.addData', {
            receiverId: 'relation-dialog-3',
            type: 'replaceForSrc',
            srcId: 'com',
            data: []
        });

        if(doShowCompanyCatalogs) {
            replaceWith = impactX.isDefined($scope.data.usrvcat, 'relationCompany.assigned');

            $scope.$broadcast('rv.addData', {
                receiverId: 'relation-dialog-3',
                type: 'replaceForSrc',
                srcId: 'com',
                data: replaceWith
            });
        }
        else {
            $scope.$broadcast('rv.addData', {
                receiverId: 'relation-dialog-3',
                type: 'replaceForSrc',
                srcId: 'com',
                data: []
            });
        }
    };

    /**
     * Updates the list of inherited catalogs.
     *
     * @param data list with selected user groups
     */
    self.updateInheritedCatalogList = function(data) {
        var idx, idList = [];

        if(data !== undefined && typeof data.length === 'number') {

            for(idx = 0; idx < data.length; idx++) {
                idList.push(data[idx].id);
            }

            if(usgCatalogListPromise && dataGen && typeof dataGen.cancel === 'function') {
                dataGen.cancel(usgCatalogListPromise);
            }

            usgCatalogListPromise = self.getUserGroupInheritedCatalogsFromServer(idList);

            usgCatalogListPromise.then(function(newData) {
                self.sendEventToCatalogRelation(newData);
                //Forget promise.
                usgCatalogListPromise = null;
            }, function() {
                //Also: Avoid cancel of failed promises.
                usgCatalogListPromise = null;
            });
        }
    };

    /**
     * Sends event to catalog relation.
     *
     * @param data event data
     */
    self.sendEventToCatalogRelation = function(data) {
        var dataToAdd = impactX.isDefined(data, 'data.relation.assigned');

        $scope.$broadcast('rv.addData', {
            receiverId: 'relation-dialog-3',
            type: 'replaceForSrc',
            srcId: 'usg',
            data: dataToAdd
        });
    };

    /**
     * Gets new data for the given list of selected user group IDs.
     *
     * @param data list of IDs
     * @return {*|promise} promise for the catalog for user groups
     */
    self.getUserGroupInheritedCatalogsFromServer = function(data) {
        var doCancel = true,
            asyncRequest = true,
            dataObj = {
                userId: '' + userId + '',
                usglist: data.join(',')
            };

        //We could also use 'GET', but who knows,
        //maybe some day the list of selected user groups will be too long for 'GET'.
        return dataGen.postAsForm(self.usgCatalogRelation, dataObj, "/user/authorizations/usergroupvcats",
            doCancel, asyncRequest);
    };

    $scope.deleteAuthorizationEntry = function(index) {
        $scope.data.authSets.authSetEntries[index].deleted = true;
        $scope.handleChange();
    };
    $scope.deleteRoleEntry = function(index) {
        $scope.data.roleSets.roleSetEntries[index].deleted = true;
        $scope.handleChange();
    };
    $scope.authorizationNeedsOwningCompanyRelation = function(searchId) {
        var entry;

        if(searchId > 0) {
            entry = $scope.data.authSets.authorizationPopup.entries.filter(function(a) {
                return a.id == searchId
            })[0];
            if(entry) {
                return entry.needsCompanyRelation;
            }
        }
        return false;
    };
    $scope.authorizationNeedsCatalogRelation = function(searchId) {
        var entry;

        if(searchId > 0) {
            entry = $scope.data.authSets.authorizationPopup.entries.filter(function(a) {
                return a.id == searchId
            })[0];
            if(entry) {
                return entry.needsCatalogRelation;
            }
        }
        return false;
    };
    $scope.roleNeedsOwningCompanyRelation = function(searchId) {
        var entry;

        if(searchId > 0) {
            entry = $scope.data.roleSets.rolePopup.entries.filter(function(a) {
                return a.id == searchId
            })[0];
            if(entry) {
                return entry.needsCompanyRelation;
            }
        }
        return false;
    };
    $scope.roleNeedsCatalogRelation = function(searchId) {
        var entry;
        if(searchId > 0) {
            entry = $scope.data.roleSets.rolePopup.entries.filter(function(a) {
                return a.id == searchId
            })[0];
            if(entry) {
                return entry.needsCatalogRelation;
            }
        }
        return false;
    };
    $scope.authorizationNeedsCompanyPopup = function(searchId) {
        var entry;

        if(searchId > 0) {
            entry = $scope.data.authSets.authorizationPopup.entries.filter(function(a) {
                return a.id == searchId
            })[0];
            if(entry) {
                return entry.needsCompanyAnchor;
            }

        }
        return false;
    };
    $scope.roleNeedsCompanyPopup = function(searchId) {
        var entry;

        if(searchId > 0) {
            entry = $scope.data.roleSets.rolePopup.entries.filter(function(a) {
                return a.id == searchId
            })[0];
            if(entry) {
                return entry.needsCompanyAnchor;
            }
        }
        return false;
    };

    /**
     * Prepares data for saving. DO NOT use this data for filling you front-end,
     * you will have no selection available.
     *
     * @param data data to prepare.
     * @return {*} data to send to server
     */
    self.prepareDataForSave = function(data) {
        var assignedCatalogsRelation,
            dataToSave = {};

        if(data) {
            //Clean up, do not send too much data!
            dataToSave = angular.copy(data, dataToSave);

            if(dataToSave.companyPopup) {
                dataToSave.companyPopup = dataGen.slimDownPopup(dataToSave.companyPopup);
            }

            if(impactX.isDefined(dataToSave, 'usrusg.relation')) {
                dataToSave.usrusg.relation = dataGen.slimDownRelation(dataToSave.usrusg.relation);
            }

            if(impactX.isDefined(dataToSave, 'usrdis.relation')) {
                dataToSave.usrdis.relation = dataGen.slimDownRelation(dataToSave.usrdis.relation);
            }

            if(impactX.isDefined(dataToSave, 'usrvcat.relation')) {
                dataToSave.usrvcat.relationCompany = {
                    assigned: [],
                    available: []
                };

                dataToSave.usrvcat.relation = dataGen.slimDownRelation(dataToSave.usrvcat.relation);

                //Remove not needed groups
                assignedCatalogsRelation = RelationViewHelperService.replaceForSrc('com', dataToSave.usrvcat.relation.assigned, []);
                assignedCatalogsRelation = RelationViewHelperService.replaceForSrc('usg', assignedCatalogsRelation, []);

                dataToSave.usrvcat.relation.assigned = assignedCatalogsRelation;
            }

            return dataToSave;
        }

        return data;
    };

    $scope.savePageData = function($event, showOthers) {
        var data = $scope.data;
        var dataObj = {
            data: self.prepareDataForSave(data)
        };

        return dataGen.post($scope, dataObj, "/user/authorizations/save").then(function() {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if(showOthers)
            {
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.USER, userId, 'userauthorizations', undefined, true);
            }
            else
            {
                PartialDialogsService.redirectToList(PartialDialogsService.TYPE.USER, undefined);
            }
        });
    };

    $scope.savePageDataBackToList = function ($event) {
        return $scope.savePageData($event, false)
    };

    $scope.savePageDataOtherDialogs = function ($event) {
        return $scope.savePageData($event, true)
    };

    function valueFunction() {
        return $scope.data && $scope.data.userCard && $scope.data.userCard.maxNumberOfUsersReached
            && !$scope.data.userCard.canSaveWithMaxNumberOfUsersReached;
    }

    $scope.addRoleSet = function() {
        var toPush = {};
        $scope.data.roleSets.roleSetEntries.push(toPush);
    };

    $scope.addAuthSet = function() {
        var toPush = {};
        $scope.data.authSets.authSetEntries.push(toPush);
    };
    $scope.handleChange = function() {
        if($scope.data && $scope.data.purchaserrelation) {
            $scope.data.isSuperUser = false;
            var i, j, k, l,
                authorizationEntry,
                authorization,
                roleSetEntry,
                role,
                superUserIndex = -1;

            $scope.data.purchaserrelation.hasPurchaserSelected = false;

            if($scope.data.authSets.authSetEntries) {
                for(i = 0; i < $scope.data.authSets.authSetEntries.length; i++) {
                    authorizationEntry = $scope.data.authSets.authSetEntries[i];
                    if(authorizationEntry.authSetId > 0) {
                        authorization = $scope.data.authSets.authorizationPopup.entries.filter(function(a) {
                            return a.id == authorizationEntry.authSetId
                        })[0];
                        if(authorization && authorization.isPurchaser && !authorizationEntry.deleted) {
                            $scope.data.purchaserrelation.hasPurchaserSelected = true;
                        }
                        if(authorization && authorization.isSuperUser && !authorizationEntry.deleted) {
                            $scope.data.isSuperUser = true;
                            superUserIndex = i;
                            break;
                            //todo: delete other
                        }
                    }
                }
            }
            if($scope.data.roleSets.roleSetEntries) {
                for(j = 0; j < $scope.data.roleSets.roleSetEntries.length; j++) {
                    roleSetEntry = $scope.data.roleSets.roleSetEntries[j];
                    if(roleSetEntry.roleSetId > 0) {
                        role = $scope.data.roleSets.rolePopup.entries.filter(function(a) {
                            return a.id == roleSetEntry.roleSetId
                        })[0];
                        if(role && role.isPurchaser && !roleSetEntry.deleted) {
                            $scope.data.purchaserrelation.hasPurchaserSelected = true;
                        }
                    }
                }
            }

            if($scope.data.isSuperUser) {
                $scope.data.purchaserrelation.hasPurchaserSelected = false;
                for(k = 0; k < $scope.data.authSets.authSetEntries.length; k++) {
                    if(k != superUserIndex) {
                        $scope.data.authSets.authSetEntries[k].deleted = true;
                    }
                }
                for(l = 0; l < $scope.data.roleSets.roleSetEntries.length; l++) {
                    $scope.data.roleSets.roleSetEntries[l].deleted = true;
                }
            }
        }
    };

    var doGetData = true;
    if(dataGen.isLastEndpointRequested) {
        doGetData = !dataGen.isLastEndpointRequested(backendEndpoint, 100);
    }

    if(doGetData) {
        $scope.getPageData();
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageDataBackToList,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            },
            {
                label: $scope.trns.saveAndForward,
                action: $scope.savePageDataOtherDialogs,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    self.getCatalogRelationData = function () {
        self.loadingCats = true;
        dataGen.postAsForm({}, {id: userId, relationData: $scope.data.usrvcat}, "/user/authorizations/catalogs/load").then(function (answer) {
            self.loadingCats = false;
            if (answer.data) {
                $scope.data.usrvcat = answer.data;
            }
        }, function () {
            self.loadingCats = false;
        })
    }
}